import { render, staticRenderFns } from "./AvatarPlaceholder.vue?vue&type=template&id=04caca50&lang=pug"
import script from "./AvatarPlaceholder.vue?vue&type=script&lang=ts"
export * from "./AvatarPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports